import { apiGet } from './client.js';
import type { CalendarEntry } from './calendarTypes.js';

export function listCalendarEntries(opts: {
  from: string;
  to: string;
}): Promise<CalendarEntry[]> {
  const params = new URLSearchParams({ from: opts.from, to: opts.to });
  return apiGet<CalendarEntry[]>(`/api/calendar?${params.toString()}`);
}
